import React from 'react';
import { MessageCircle, Calendar } from 'lucide-react';
import { useSiteContent, trackEvent } from '../context/SiteContext';
import { trackWhatsAppConversion } from '../utils/consent';
import './Hero.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getEmbedUrl = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=0&rel=0&mute=1`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=0&muted=1`;
  return null;
};

const Hero = () => {
  const { hero, settings } = useSiteContent();

  const scrollToForm = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleWhatsApp = () => {
    const phone = settings?.whatsappNumber || '491793912947';
    const message = encodeURIComponent('Hallo, ich interessiere mich fuer die BD Event Location. Ich wuerde gerne einen Termin anfragen.');
    const url = `https://wa.me/${phone}?text=${message}`;
    trackEvent('whatsapp_click');
    trackWhatsAppConversion(url);
  };

  const heroType = hero?.heroType || 'image';
  const imageUrl = hero?.imageUrl?.startsWith('/api/') ? `${API_URL}${hero.imageUrl}` : hero?.imageUrl;
  const embedUrl = getEmbedUrl(hero?.videoUrl);

  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-background">
        {heroType === 'video' && embedUrl ? (
          <iframe
            src={embedUrl}
            title="Hero Video"
            className="hero-video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <img
            src={imageUrl || ''}
            alt={hero?.imageAlt || 'BD Event Location'}
            className="hero-image"
          />
        )}
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-large">{hero?.headline || 'Exklusive Eventlocation'}</h1>
          <p className="hero-subtitle">{hero?.subheadline || ''}</p>
          <div className="hero-buttons">
            <button className="btn-hero btn-hero-primary" onClick={handleWhatsApp} data-testid="hero-whatsapp-btn">
              <MessageCircle size={20} />
              {hero?.button1Text || 'WhatsApp Anfrage'}
            </button>
            <button className="btn-hero btn-hero-secondary" onClick={scrollToForm} data-testid="hero-cta-btn">
              <Calendar size={20} />
              {hero?.button2Text || 'Termin sichern'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
